import { useState } from "react";
import { faqItems } from "@/mocks/leakHome";

const promises = [
  { icon: "ri-eye-off-line", title: "绝对匿名", desc: "不记名、不追 IP，投稿人的身份永远只有我知道。" },
  { icon: "ri-shield-check-line", title: "先审后发", desc: "内容审核后再上墙，守住底线，也守得住想说的人。" },
  { icon: "ri-timer-line", title: "快速过审", desc: "正常情况下 4 小时内给答复，急稿优先处理。" },
  { icon: "ri-delete-bin-6-line", title: "随时下墙", desc: "一个上墙码就能撤销，想删随时说，24h 办妥。" },
];

export default function FaqTrust() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="w-full bg-[#faf8f4] py-10 md:py-14">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs font-bold tracking-widest text-red-500">TRUST & FAQ</p>
          <h2 className="mt-1 text-2xl font-black text-stone-800 md:text-3xl">
            为什么可以放心说给我听？
          </h2>
          <p className="mt-2 text-sm text-stone-500">
            匿名不是嘴上说说，是每一篇上墙背后都守好的承诺。
          </p>
        </div>

        {/* 承诺墙 */}
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {promises.map((p) => (
            <div
              key={p.title}
              className="rounded-2xl border border-stone-100 bg-white p-5 text-center md:p-6"
            >
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-red-50 text-red-600">
                <i className={`${p.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-stone-800">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-stone-500">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* FAQ */}
        <div className="mt-10 grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
          <div>
            <h3 className="text-xl font-black text-stone-800 md:text-2xl">投稿常见问题</h3>
            <p className="mt-2 text-sm leading-relaxed text-stone-500">
              还没想明白怎么投？先把这几个问题点开看看，基本都能解决你的犹豫。
            </p>
            <div className="mt-5 space-y-3">
              {faqItems.slice(0, 2).map((f) => (
                <div
                  key={f.q}
                  className="rounded-2xl border border-amber-200 bg-amber-50/70 p-4"
                >
                  <p className="flex items-start gap-2 text-sm font-semibold text-stone-800">
                    <i className="ri-question-mark text-amber-500"></i>
                    {f.q}
                  </p>
                  <p className="mt-1 pl-6 text-sm leading-relaxed text-stone-500">{f.a}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="overflow-hidden rounded-2xl border border-stone-100 bg-white">
            {faqItems.map((f, i) => (
              <div key={f.q} className="border-b border-stone-100 last:border-0">
                <button
                  onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="text-sm font-bold text-stone-800 md:text-base">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-red-600 transition ${
                      openIdx === i ? "bg-red-100 rotate-45" : "bg-stone-100"
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {openIdx === i && (
                  <p className="px-5 pb-4 pl-5 text-sm leading-relaxed text-stone-500 md:pl-[3.25rem]">
                    {f.a}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}